export default __webpack_public_path__ + "static/media/hub-app-icon-mark.d80e381b.svg";